import EnvVars from "../env-vars"

export const ENVIRONMENTS = {
  burner: `burner`,
  codespace: `codespace`,
  development: `development`,
  production: `production`,
  qa: `qa`,
  staging: `staging`,
}

export type Environments = keyof typeof ENVIRONMENTS

export const getNodeEnv = (): Environments => {
  return EnvVars.NODE_ENV as Environments
}
